import React from "react";

import ClientProfileView from "../../../Company-portal/Clients/ViewClient/ClientProfileView";
import useAdminViewClient from "../hooks/useAdminViewClient";

const ViewClient = () => {
  const viewProps = useAdminViewClient();

  return <ClientProfileView {...viewProps} />;
};

export default ViewClient;
